<div class="container">
  <div class="icon recurring" [hidden]="true">
    <div inlineSVG="/assets/icons/thum-trash.svg" *ngIf="isRecurring()"></div>
  </div>
  <div class="icon recording" (click)="toggleJobRecording()">
    <div [inlineSVG]="recordingIcon"></div>
  </div>
  <div class="icon settings" (click)="showJobSettings()">
    <div inlineSVG="/assets/icons/pop-edit.svg"></div>
  </div>
  <div class="icon delete" (click)="deleteJob()" [hidden]="isRunning">
    <div inlineSVG="/assets/icons/thum-trash.svg"></div>
  </div>
</div>
